import api from '../api';

export const getPicklistAssemblies = (query) => () =>
  api.addAssemblyPopup
    .getAssembliesApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));
